import {
  InternalNetworkActionClassSchema,
  InternalNetworkExecutionTierSchema,
  SignalCategorySchema,
} from '@terra/shared-schemas-orchestrator';
import { z } from 'zod';
import { ALLOWED_REMOTE_EXECUTION_COMMANDS } from './internal-network-c2.constants';
import {
  ScenarioEvidencePlanSchema,
  ScenarioTypedTaskPlanStepSchema,
} from './internal-network.schema';

export const AiAuthoredScenarioTypedTaskPlanStepSchema =
  ScenarioTypedTaskPlanStepSchema.extend({
    command: z.enum(ALLOWED_REMOTE_EXECUTION_COMMANDS).optional(),
  });

export const AiAuthoredScenarioTypedTaskPlanSchema = z
  .object({
    signalCategory: SignalCategorySchema,
    steps: z.array(AiAuthoredScenarioTypedTaskPlanStepSchema),
  })
  .superRefine((value, ctx) => {
    value.steps.forEach((step, index) => {
      const pathFields = [step.sourceHost, step.targetHost, step.edgeType];
      const pathFieldCount = pathFields.filter(
        (field) => typeof field === 'string' && field.trim().length > 0,
      ).length;
      if (pathFieldCount !== 0 && pathFieldCount !== pathFields.length) {
        ctx.addIssue({
          code: 'custom',
          message:
            'sourceHost, targetHost, and edgeType must be provided together',
          path: ['steps', index],
        });
      }
    });
  });

export const AiAuthoredScenarioDraftSchema = z
  .object({
    actionClass: InternalNetworkActionClassSchema,
    executionTier: InternalNetworkExecutionTierSchema,
    blastRadiusSummary: z.string(),
    typedTaskPlan: AiAuthoredScenarioTypedTaskPlanSchema,
    evidencePlan: ScenarioEvidencePlanSchema,
  })
  .strict();

export type AiAuthoredScenarioDraftDto = z.infer<
  typeof AiAuthoredScenarioDraftSchema
>;
